import React from 'react'
import { getTranslatedTextByKey, redirectToHomepage, redirectToChainMenu } from 'utils/utils'
import { Logo } from 'components/common/Logo'
import { ERROR_IMAGE_ROUTE } from 'utils/staticFilesRoutes'
import {
	ErrorPageContainer,
	ErrorPageContent,
	ErrorPageContentButton,
	ErrorPageContentDescription,
	ErrorPageContentImage,
	ErrorPageContentSubTitle,
	ErrorPageContentTitle,
	ErrorPageHeaderButton,
	ErrorPageOneButtonHeader,
	GENERIC_ERROR_DESCRIPTION,
	INVALID_ROUTE_SUBTITLE,
	INVALID_ROUTE_TITLE,
} from 'static/components/errors/ErrorPagesSharedComponents'
import { getThemeUrl } from 'utils/theme/themeManager'
import type { RouteComponentProps } from 'react-router-dom'
import { THEME_STRATEGY } from 'constants/theme'
import { inject, observer } from 'mobx-react'
import type _Infra from 'mobx/Infra'
import type _User from 'mobx/User'
import { useRouter } from 'next/router'

interface InvalidRouteErrorPageProps {
	Infra: typeof _Infra
	User: typeof _User
}

const InvalidRouteErrorPage: React.FC<Partial<RouteComponentProps>> = inject(
	'User',
	'Infra'
)(
	observer(({ Infra, User }: InvalidRouteErrorPageProps & Partial<RouteComponentProps>) => {
		const router = useRouter()

		const { theme, c: chainId, brand } = Infra.appParams
		const language = User.preferredLanguage || Infra.appParams.l

		const imgPath = `${getThemeUrl(theme || THEME_STRATEGY.GENERIC, chainId, brand)}/assets`

		return (
			<ErrorPageContainer>
				<ErrorPageOneButtonHeader>
					<Logo />
					<ErrorPageHeaderButton $type="secondary" onClick={() => redirectToHomepage(router)} fullWidth>
						{getTranslatedTextByKey('conversationText.webviewFlow.backToHomepage', 'Back to homepage')}
					</ErrorPageHeaderButton>
				</ErrorPageOneButtonHeader>
				<ErrorPageContent>
					<ErrorPageContentImage src={`${imgPath}${ERROR_IMAGE_ROUTE}`} alt="error image" />
					<ErrorPageContentTitle variant="HomePageTitle" component="h1">
						{getTranslatedTextByKey('eCommerce.errorPages.invalidRouteTitle', INVALID_ROUTE_TITLE)}
					</ErrorPageContentTitle>
					<ErrorPageContentSubTitle variant="SubheadHighlighted">
						{getTranslatedTextByKey('eCommerce.errorPages.invalidRouteSubtitle', INVALID_ROUTE_SUBTITLE)}
					</ErrorPageContentSubTitle>
					<ErrorPageContentDescription variant="Subhead" component="div">
						{getTranslatedTextByKey('eCommerce.errorPages.genericErrorDescription', GENERIC_ERROR_DESCRIPTION)}
					</ErrorPageContentDescription>
					<ErrorPageContentButton onClick={() => redirectToChainMenu(language, router)} $size="big">
						{getTranslatedTextByKey('webviewFlow.ok', 'OK')}
					</ErrorPageContentButton>
				</ErrorPageContent>
			</ErrorPageContainer>
		)
	}) as React.FC<Partial<RouteComponentProps>>
)

export default InvalidRouteErrorPage
